import {
  Dialog as MuiDialog,
  DialogProps as MuiDialogProps,
  dialogContentClasses,
  dialogTitleClasses,
  styled,
} from '@mui/material';
import { Spacing5 } from '../spacing';

export interface DialogProps extends MuiDialogProps {
  gutters?: 'dense' | 'normal';
}

export const Dialog = styled(MuiDialog)<DialogProps>(({ gutters }) => ({
  ...(gutters === 'normal'
    ? {
      [`.${dialogTitleClasses.root}`]: {
        marginBlockEnd: Spacing5,
      },
      [`.${dialogContentClasses.root}, .${dialogContentClasses.root}.${dialogContentClasses.dividers}`]:
          {
            marginBlockEnd: Spacing5,
          },
    }
    : {}),
}));

Dialog.defaultProps = {
  gutters: 'dense',
};
